import { DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Input, inject, output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalHeaderComponent } from '../modal-header/modal-header.component';
import { ModalFooterComponent } from '../modal-footer/modal-footer.component';

@Component({
  selector: 'app-modal-base',
  imports: [CommonModule, TranslateModule, ModalHeaderComponent, ModalFooterComponent],
  templateUrl: './modal-base.component.html',
})
export class ModalBaseComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() hasTour: boolean = false;
  @Input() showCloseIcon: boolean = true;
  @Input() primaryButtonText: string = 'done';
  @Input() secondaryButtonText: string = 'cancel';
  @Input() showPrimaryButton: boolean = true;
  @Input() showSecondaryButton: boolean = true;
  @Input() primaryButtonVariant: 'primary' | 'danger' = 'primary';
  @Input() primaryButtonId: string = '';
  @Input() secondaryButtonId: string = '';
  @Input() modalClass: string = '';
  @Input() primaryButtonDisabled: boolean = false;
  @Input() modalBodyClass: string = '';

  primaryClick = output();
  secondaryClick = output();
  close = output();
  tour = output();

  protected dialogRef = inject(DialogRef);
  protected isButtonDisabledSignal = signal(false);

  onPrimaryClick(): void {
    this.primaryClick.emit();
  }

  onSecondaryClick(): void {
    this.secondaryClick.emit();
  }

  onClose(): void {
    this.close.emit();
    this.dialogRef.close();
  }

  onTour(): void {
    this.tour.emit();
  }

  protected isButtonDisabled(): boolean {
    return this.isButtonDisabledSignal();
  }

  protected setButtonDisabled(disabled: boolean): void {
    this.isButtonDisabledSignal.set(disabled);
  }
}
